module.exports = __webpack_public_path__ + "static/media/favicon.5bbf66db.ico";